import React from 'react';
import PropTypes from 'prop-types';
import AppService from '../service/AppService';
import WebMediaQuery from './WebMediaQuery';

export default class SearchResultBarItem extends React.Component {

  static propTypes = {
    title: PropTypes.any.isRequired,
    count: PropTypes.any,
    shortTitle: PropTypes.any,
    icon: PropTypes.string,
    url: PropTypes.string,
    selected: PropTypes.bool,
    openOnNewTab: PropTypes.bool,
    className: PropTypes.string,
    onMouseOver: PropTypes.func,

  };

  constructor(props) {
    super(props);

    this.state = {
      showSubMenu: true,
    }
  }

  onMouseOver(e) {
    if (this.props.onMouseOver) {
      this.props.onMouseOver();
      e.preventDefault();
    }
  }

  render() {

    let {
      title,
      count,
      shortTitle,
      imageUrl,
      url,
      className,
      icon,
      selected,
      openOnNewTab,
    } = this.props;

    let {
      showSubMenu
    } = this.state;

    let display = 'none';
    if (showSubMenu) {
      display = 'block';
    }

    let selectedShortTitle = shortTitle?shortTitle:title;

    let displayCount = count>=0?count.toLocaleString('en'):'';
    if (count > 9999) {
      displayCount = '9,999+';
    }

    if (count >= 0) {
      displayCount = `(${displayCount})`;
    } else if (count == '-') {
      displayCount = `( ${count} )`;
    }

    return (
      <div onMouseOver={::this.onMouseOver} style={{flex: '0 0 auto'}}>
        <a className={`searchResultLink  ${selected?'selected':''} ${className?className:''}`} href={url} target={openOnNewTab?'_blank':'_self'}>
          {icon && <div className={`naviLinkLogo ${icon}`} />}
          <div className="title">
            {title}
          </div>
          <div className="number">
            <span style={{verticalAlign: 'middle'}} >{displayCount}</span>
          </div>
        </a>
      </div>
    )
  }

}